import { render } from "./BaseRadio.vue?vue&type=template&id=5752dd57"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"

import exportComponent from "/home/idse-console/webapps/idse-console/releases/1793606021595/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__